<template>
  <div
    :class="{
      'in-quicklist': inQuicklist,
      'previously-played': previouslyPlayed,
    }"
    @click.right.prevent="onRightClick"
    class="track-list-row-template-container"
    v-on:click.prevent="onTrackClick"
  >
    <div
      :class="'track-list-row-' + track.id"
      class="row track-list-row"
      v-bind:data-track-id="track.id"
    >
      <div
        :class="{ 'col-sm-3': !isMobile, 'col-sm-4': isMobile }"
        class="col-name"
      >
        <a
          :class="collapseToggleClass"
          :style="{
            visibility: hasSubtracks || !projectId ? '' : 'hidden',
            opacity: hasSubtracks ? '1' : '0',
          }"
          class="collapse-toggle cancel-track-draggable cancel-track-play"
          data-toggle="collapse"
          v-on:click="handleCollapseToggle"
        >
          <i
            :class="{ 'sub-track-in-quicklist': subtracksInQuicklist }"
            class="material-icons cancel-track-play"
          ></i
          >&nbsp;
        </a>

        <span
          class="drag-track draggable-cursor cancel-track-draggable h-100 d-inline-block"
          v-if="projectId && projectId != 'quicklistGuest' && !isMobile"
        >
          <i class="material-icons cancel-track-play cancel-track-draggable"
            >drag_handle</i
          >
        </span>

        <a href="#" v-bind:title="name">
          <span class="track-name">{{ name }}</span>
        </a>
      </div>

      <div :class="{ 'col-time-mobile': isMobile }" class="col-sm-1 col-time">
        <span class="time"
          ><span class="d-inline d-md-none">Time:&nbsp;</span
          >{{ time | lengthToMinutes }}</span
        >
        <span class="load-icon"
          ><i class="material-icons icon-circle rotating">cached</i></span
        >
        <span class="load-error-icon"
          ><i class="material-icons icon-circle">priority_high</i></span
        >
        <div class="mobile-actions d-block d-md-none">
          <a
            @click.prevent="email()"
            class="action cancel-track-play normal-tooltip"
            data-placement="top"
            data-toggle="tooltip"
            href="#"
            title="Share"
          >
            <i class="material-icons cancel-track-play">share</i>
          </a>

          <div class="dropdown">
            <a
              class="dropdown-toggle action"
              href="#"
              v-on:click.prevent="
                toggleTrackListMobileMenu('trackListRowMenuMobile' + id)
              "
            >
              <i class="material-icons cancel-track-play">menu</i>
            </a>
          </div>

          <a
            @click.prevent="download"
            class="action cancel-track-play normal-tooltip"
            data-placement="top"
            data-toggle="tooltip"
            href="#"
            title="Download Track"
          >
            <i class="material-icons cancel-track-play">cloud_download</i>
          </a>

          <a
            @click.prevent="findSimilar"
            class="action cancel-track-play normal-tooltip"
            data-placement="top"
            data-toggle="tooltip"
            href="#"
            title="FindAlike"
          >
            <i class="material-icons cancel-track-play find-similar-icon"
              >search</i
            >
          </a>

          <a
            :style="{
              visibility: lyrics ? '' : 'hidden',
              opacity: lyrics ? '1' : '0',
            }"
            @click.prevent="openLyrics()"
            class="action cancel-track-play normal-tooltip"
            data-placement="top"
            data-toggle="tooltip"
            href="#"
            title="Lyrics"
          >
            <i class="material-icons cancel-track-play">queue_music</i>
          </a>
        </div>

        <div class="clearfix"></div>
      </div>

      <div
        class="col-desc"
        data-toggle="tooltip"
        v-bind:class="{
          'col-sm-3': waveformVisible,
          'col-sm-5': !waveformVisible,
        }"
        v-if="!isMobile"
      >
        <span>{{ description }}</span>
      </div>

      <div
        :class="{ 'col-sm-2': !isMobile, 'col-sm-3': isMobile }"
        class="col-album"
      >
        <span v-if="album">{{ album }}</span>
        <span v-if="!album">&nbsp</span>
      </div>

      <div
        :class="{
          'col-waveform-mobile': isMobile,
          'col-sm-4 d-flex col-actions-waveform-visible pr-0': waveformVisible,
          'col-sm-1 col-actions-waveform-hidden': !waveformVisible,
        }"
        class="cancel-track-draggable col-actions"
      >
        <a
          @click.prevent="email()"
          class="action cancel-track-play d-none d-md-block"
          href="#"
        >
          <i
            class="material-icons cancel-track-play share-icon"
            data-delay='{"show":"300", "hide":"200"}'
            data-placement="bottom"
            data-template='<div class="tooltip custom-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
            data-toggle="tooltip"
            title="Share Track"
            >share</i
          >
        </a>

        <div class="menu-dropdown dropdown d-none d-md-block">
          <a
            aria-expanded="false"
            aria-haspopup="true"
            class="dropdown-toggle action"
            data-toggle="dropdown"
            href="#"
            role="button"
            v-bind:id="'trackListRowMenu' + id"
          >
            <i
              class="material-icons cancel-track-play menu-icon"
              data-delay='{"show":"300", "hide":"200"}'
              data-placement="bottom"
              data-template='<div class="tooltip custom-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
              data-toggle="tooltip"
              ref="menuIcon"
              title="Menu"
              >menu</i
            >
          </a>

          <div
            class="dropdown-menu"
            v-bind:aria-labelledby="'trackListRowMenu' + id"
          >
            <a
              @click.prevent="openDetails()"
              class="dropdown-item cancel-track-play"
              href="#"
              >Track details</a
            >
            <a
              @click.prevent="addToProject()"
              class="dropdown-item cancel-track-play"
              href="#"
              >Add to project</a
            >
            <a
              v-if="projectId && !isQuicklistProject()"
              @click.prevent="removeFromProject()"
              class="dropdown-item cancel-track-play dropdown-item-remove-from-project"
              href="#"
              >Remove from project</a
            >
            <a
              @click.prevent="license()"
              class="dropdown-item cancel-track-play"
              href="#"
              >License now</a
            >
            <a
              @click.prevent="email()"
              class="dropdown-item cancel-track-play"
              href="#"
              >Share track</a
            >
          </div>
        </div>

        <a
          @click.prevent="download"
          class="action cancel-track-play d-none d-md-block"
          href="#"
        >
          <i
            class="material-icons cancel-track-play row-download-button"
            data-delay='{"show":"300", "hide":"200"}'
            data-placement="bottom"
            data-template='<div class="tooltip custom-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
            data-toggle="tooltip"
            title="Download Track"
            >cloud_download</i
          >
        </a>

        <a
          @click.prevent="findSimilar"
          class="action cancel-track-play d-none d-md-block"
          href="#"
        >
          <i
            class="material-icons cancel-track-play row-download-button find-similar-icon"
            data-delay='{"show":"300", "hide":"200"}'
            data-placement="bottom"
            data-template='<div class="tooltip custom-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
            data-toggle="tooltip"
            title="FindAlike"
            >search</i
          >
        </a>

        <a
          :style="{
            visibility: lyrics ? '' : 'hidden',
            opacity: lyrics ? '1' : '0',
          }"
          @click.prevent="openLyrics()"
          class="action cancel-track-play d-none d-md-block"
          href="#"
        >
          <i class="material-icons cancel-track-play" title="Lyrics"
            >queue_music</i
          >
        </a>

        <div
          @click="onWaveformContainerClick"
          class="waveform-container cancel-track-play"
          v-if="waveformVisible"
        >
          <img
            class="d-block track-progress-seek cancel-track-play"
            v-bind:src="wavimage"
            v-if="track && wavimage"
          />

          <div
            class="track-progress-visualiser cancel-track-play"
            v-bind:style="{ width: waveformProgress.toFixed(1) + '%' }"
            v-show="nowPlaying"
          >
            <img
              class="cancel-track-play"
              v-bind:src="wavimage"
              v-bind:style="{ width: trackProgressVisualizerWidth + 'px' }"
            />
          </div>

          <div style="margin-top: 15px" v-if="!wavimage">No Waveform</div>
        </div>

        <a
          @click.prevent="handleRemoveFromProjectClick"
          class="delete-track action cancel-track-play normal-tooltip"
          href="#"
          v-if="projectId && !isQuicklistProject() && !isMobile"
        >
          <i
            class="material-icons cancel-track-play"
            data-delay='{"show":"300", "hide":"200"}'
            data-placement="bottom"
            data-template='<div class="tooltip custom-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
            data-toggle="tooltip"
            title="Delete"
            >delete</i
          >
        </a>
      </div>
    </div>

    <div class="dropdown-menu" v-bind:class="'trackListRowMenuMobile' + id">
      <a
        @click.prevent="toggleTrackListMobileMenu()"
        class="close-dropdown-mobile"
        href="#"
        ><i class="material-icons cancel-track-play">close</i></a
      >
      <div class="dropdown-track-name">{{ name }}</div>
      <div class="dropdown-track-album">{{ album }}</div>
      <a
        @click.prevent="openDetails()"
        class="dropdown-item cancel-track-play"
        href="#"
        >Track details</a
      >
      <a
        @click.prevent="addToProject()"
        class="dropdown-item cancel-track-play"
        href="#"
        >Add to project</a
      >
      <a
        @click.prevent="
          onRightClick();
          toggleTrackListMobileMenu();
        "
        class="dropdown-item dropdown-item-mobile-add-quicklist cancel-track-play"
        href="#"
        >Add to Quicklist</a
      >
      <a
        @click.prevent="
          onRightClick();
          toggleTrackListMobileMenu();
        "
        class="dropdown-item dropdown-item-mobile-remove-quicklist cancel-track-play"
        href="#"
        >Remove from Quicklist</a
      >
      <a
        @click.prevent="license()"
        class="dropdown-item cancel-track-play"
        href="#"
        >License now</a
      >
      <a
        v-if="projectId && !isQuicklistProject()"
        @click.prevent="removeFromProject()"
        class="dropdown-item cancel-track-play dropdown-item-remove-from-project"
        href="#"
        >Remove from project</a
      >
      <a
        @click.prevent="email()"
        class="dropdown-item cancel-track-play"
        href="#"
        >Share track</a
      >
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { playerService } from "../player-service";
import { audioService } from "../audio-service";
import { lengthToMinutes } from "../filters/length-to-minutes";

export default Vue.component("track-list-row", {
  data: function () {
    return {
      id: this.track.id,
      name: this.track.title,
      time: this.track.length,
      year: this.track.year,
      description: this.track.comments ? this.track.comments : "No Description",
      album:
        typeof this.track.album !== "undefined" && this.track.album !== null
          ? this.track.album.name
          : null,
      hasSubtracks:
        typeof this.track.subtracks !== "undefined" &&
        this.track.subtracks.length
          ? true
          : false,
      waveformVisible: true,
      lyrics: this.track.lyrics,
      fullDescriptionShow: false,
      nowPlaying: false,
      waveformProgress: 0,
      trackProgressVisualizerWidth: 0,
      isPlaying: false,
      subtracksInQuicklist: false,
      inQuicklist: false,
    };
  },

  props: {
    track: {
      type: Object,
      required: true,
    },

    isParentTrack: {
      type: Boolean,
      required: false,
      default: true,
    },

    parentUid: {
      type: Number,
      required: true,
    },

    asseturl: {
      type: String,
      required: true,
    },

    projectId: {
      required: false,
      default: false,
    },

    expanded: {
      default: false,
    },
  },

  computed: {
    wavimage: function () {
      return this.track.wavimg &&
        typeof this.track.album !== "undefined" &&
        this.track.album !== null
        ? this.asseturl +
            "/tracks/" +
            this.track.album.code +
            "/" +
            this.track.wavimg
        : null;
    },

    collapseToggleClass: function () {
      return (
        "collapse-track-" +
        this.track.id +
        " " +
        (!this.expanded ? " intended-collapse" : "intended-uncollapsed")
      );
    },

    previouslyPlayed: function () {
      if (!this.track) {
        return false;
      }

      return (
        JSON.parse(playerService.getLs("trackhistory")).indexOf(
          this.track.id,
        ) !== -1
      );
    },

    isMobile: function () {
      return $("html").hasClass("is-mobile-os") || window.innerWidth < 768;
    },
  },

  mounted: function () {
    let ctx = this;

    // Do we need to display/hide the waveform when loaded. Lets check on the window initially
    this.waveformVisible = window.waveformvisible;
    playerService.$on("waveform-toggled", this.onWaveformToggled);
    playerService.$on("projects-updated", this.onQuicklistStateChanged);
    playerService.$on("quicklist-updated", this.onQuicklistStateChanged);
    playerService.$on(
      "quicklist-guest-ls-updated",
      this.onQuicklistStateChanged,
    );

    if (window.authenticatedUserQuicklistId !== false) {
      playerService.$on(
        `project-updated-${window.authenticatedUserQuicklistId}`,
        this.onQuicklistProjectUpdated,
      );
    }

    // Figure out if the currently now playing track is this one.
    if (window.nowPlayingId == this.track.id) {
      if (this.nowPlaying != true) {
        this.nowPlaying = true;
      }
    } else {
      if (this.nowPlaying != false) {
        this.nowPlaying = false;
      }
    }

    // Update the first track played
    audioService.$on("stream-track", this.onAudioServiceStreamTrack);

    // If current track is playing, bind the audio service track playing progress
    if (window.nowPlayingId == this.track.id) {
      audioService.$on(
        "audio-service-progress-percent-updated",
        this.handleProgressPercentUpdated,
      );
    }

    // Keep the background waveform up to date.
    window.addEventListener("resize", this.onWindowResize);

    // Run the initial on window resize event initially.
    this.onWindowResize();

    this.refreshSubtracksInQuicklistState();

    // Initialise inQuicklist correctly on mount — the data property defaults to false
    // but tracks inside the quicklist tab or already in the quicklist must show green immediately.
    this.inQuicklist = this.isTrackInQuicklist(this.track.id);
  },

  beforeDestroy: function () {
    // Unbind waveform toggled listener
    playerService.$off("waveform-toggled", this.onWaveformToggled);
    playerService.$off("projects-updated", this.onQuicklistStateChanged);
    playerService.$off("quicklist-updated", this.onQuicklistStateChanged);
    playerService.$off(
      "quicklist-guest-ls-updated",
      this.onQuicklistStateChanged,
    );

    if (window.authenticatedUserQuicklistId !== false) {
      playerService.$off(
        `project-updated-${window.authenticatedUserQuicklistId}`,
        this.onQuicklistProjectUpdated,
      );
    }

    // Unbind the audio service stream track listener
    audioService.$off("stream-track", this.onAudioServiceStreamTrack);

    // Unbind the audio service track playing progress
    audioService.$off(
      "audio-service-progress-percent-updated",
      this.handleProgressPercentUpdated,
    );

    // Remove event listening to window resizes.
    window.removeEventListener("resize", this.onWindowResize);

    // Remove dragdrop & tooltips stuff if it isn't already
    let $currentTrackListRow = window
      .jqueryWrapper(this.$el)
      .find(".track-list-row");
    if (
      window.lastMousemovedTrackListRow !== null &&
      $currentTrackListRow.length &&
      $currentTrackListRow[0] == window.lastMousemovedTrackListRow
    ) {
      if (
        typeof window
          .jqueryWrapper(window.lastMousemovedTrackListRow)
          .draggable("instance") !== "undefined"
      ) {
        window.dragDropWrapper(
          window.lastMousemovedTrackListRow,
          "destroy",
          "draggable",
        );
      }

      window.webpackDestroyBsTooltipWorkaround(
        $(this.$el).find('[data-toggle="tooltip"], .menu-dropdown .menu-icon'),
      );
      window.webpackDestroyBsTooltipWorkaround(
        $(this.$el).find('[data-toggle="tooltip"], .menu-dropdown .share-icon'),
      );
      window
        .jqueryWrapper(this.$el)
        .find(".menu-dropdown")
        .off("shown.bs.dropdown");
      window
        .jqueryWrapper(this.$el)
        .find(".menu-dropdown")
        .off("hidden.bs.dropdown");
    }
  },

  methods: {
    onQuicklistStateChanged: function () {
      this.refreshSubtracksInQuicklistState();
      this.inQuicklist = this.isTrackInQuicklist(this.track.id);
      this.$forceUpdate();
    },

    onQuicklistProjectUpdated: function (project) {
      if (project && typeof project.trackids !== "undefined") {
        window.quicklistTrackIds = project.trackids;
      }

      this.onQuicklistStateChanged();
    },

    isQuicklistProject: function () {
      if (this.projectId === "quicklistGuest") {
        return true;
      }

      if (
        this.projectId === false ||
        window.authenticatedUserQuicklistId === false
      ) {
        return false;
      }

      return (
        parseInt(this.projectId, 10) ===
        parseInt(window.authenticatedUserQuicklistId, 10)
      );
    },

    isTrackInQuicklist: function (trackId) {
      return (
        Array.isArray(window.quicklistTrackIds) &&
        window.quicklistTrackIds.indexOf(trackId) !== -1
      );
    },

    refreshSubtracksInQuicklistState: function () {
      if (!this.hasSubtracks || !Array.isArray(this.track.subtracks)) {
        this.subtracksInQuicklist = false;
        return;
      }

      this.subtracksInQuicklist = this.track.subtracks.some((subtrack) =>
        this.isTrackInQuicklist(subtrack.id),
      );
    },

    updateGuestQuicklistCount: function () {
      if (window.playerApp) {
        window.playerApp.quicklistGuestTrackCount =
          window.quicklistTrackIds.length;
      }
    },

    addTrackToLsQuicklist: function () {
      // Get the current guest quicklist.
      let quicklistGuestLS = playerService.getLs("quicklistguest");

      // Doesn't exist or is just an empty string, convert to an array.
      if (quicklistGuestLS == "") {
        quicklistGuestLS = [];
      } else {
        quicklistGuestLS = JSON.parse(quicklistGuestLS);
      }

      let subtrackless = JSON.parse(JSON.stringify(this.track));
      delete subtrackless.subtracks;

      // Add the new track.
      quicklistGuestLS.push(subtrackless);

      // Stringify the lot and restore in LS.
      playerService.setLs("quicklistguest", JSON.stringify(quicklistGuestLS));

      // Add it in the quicklist trackids too!
      window.quicklistTrackIds.push(subtrackless.id);

      // For any open views, highlight it.
      $(".track-list-row-" + subtrackless.id)
        .parent()
        .addClass("in-quicklist");

      if (
        $(".track-list-row-" + subtrackless.id)
          .closest("div.card-track-row")
          .hasClass("card-subtrack-row")
      ) {
        $(".track-list-row-" + subtrackless.id)
          .closest("div.card-track-parent-row")
          .find(".collapse-toggle i")
          .addClass("sub-track-in-quicklist");
      }

      this.updateGuestQuicklistCount();
    },

    removeTrackFromLsQuicklist: function () {
      // Get the current guest quicklist.
      let quicklistGuestLS = playerService.getLs("quicklistguest");

      // Doesn't exist or is just an empty string, convert to an array.
      if (quicklistGuestLS == "") {
        quicklistGuestLS = [];
      } else {
        quicklistGuestLS = JSON.parse(quicklistGuestLS);
      }

      for (let trackIndex in quicklistGuestLS) {
        if (quicklistGuestLS.hasOwnProperty(trackIndex)) {
          if (quicklistGuestLS[trackIndex].id == this.track.id) {
            quicklistGuestLS.splice(trackIndex, 1);

            $(".track-list-row-" + this.track.id)
              .parent()
              .removeClass("in-quicklist");

            if (
              $(".track-list-row-" + this.track.id)
                .closest("div.card-track-row")
                .hasClass("card-subtrack-row")
            ) {
              if (
                $(".track-list-row-" + this.track.id)
                  .closest("div.card-track-parent-row")
                  .find(
                    ".card-subtrack-row .track-list-row-template-container.in-quicklist",
                  ).length < 1
              ) {
                $(".track-list-row-" + this.track.id)
                  .closest("div.card-track-parent-row")
                  .find(".collapse-toggle i")
                  .removeClass("sub-track-in-quicklist");
              }
            }
          }
        }
      }

      // Stringify the lot and restore in LS.
      playerService.setLs("quicklistguest", JSON.stringify(quicklistGuestLS));

      // Remove from quicklistrackids.
      for (let trackIndex in window.quicklistTrackIds) {
        if (window.quicklistTrackIds.hasOwnProperty(trackIndex)) {
          if (window.quicklistTrackIds[trackIndex] == this.track.id) {
            window.quicklistTrackIds.splice(trackIndex, 1);

            $(".track-list-row-" + this.track.id)
              .parent()
              .removeClass("in-quicklist");

            if (
              $(".track-list-row-" + this.track.id)
                .closest("div.card-track-row")
                .hasClass("card-subtrack-row")
            ) {
              if (
                $(".track-list-row-" + this.track.id)
                  .closest("div.card-track-parent-row")
                  .find(
                    ".card-subtrack-row .track-list-row-template-container.in-quicklist",
                  ).length < 1
              ) {
                $(".track-list-row-" + this.track.id)
                  .closest("div.card-track-parent-row")
                  .find(".collapse-toggle i")
                  .removeClass("sub-track-in-quicklist");
              }
            }
          }
        }
      }

      this.updateGuestQuicklistCount();
    },

    onRemoveQuicklistClass: function (trackId) {
      for (let trackIndex in window.quicklistTrackIds) {
        if (window.quicklistTrackIds.hasOwnProperty(trackIndex)) {
          if (window.quicklistTrackIds[trackIndex] == trackId) {
            window.quicklistTrackIds.splice(trackIndex, 1);

            let $trackListRow = $(this.$el).find(".track-list-row-" + trackId);

            if ($trackListRow.length) {
              $trackListRow.parent().removeClass("in-quicklist");

              if (
                $trackListRow
                  .closest("div.card-track-row")
                  .hasClass("card-subtrack-row")
              ) {
                if (
                  $trackListRow
                    .closest("div.card-track-parent-row")
                    .find(
                      ".card-subtrack-row .track-list-row-template-container.in-quicklist",
                    ).length < 1
                ) {
                  $trackListRow
                    .closest("div.card-track-parent-row")
                    .find(".collapse-toggle i")
                    .removeClass("sub-track-in-quicklist");
                }
              }
            }
          }
        }
      }
    },

    onWaveformContainerClick: async function (e) {
      if (!this.isPlaying) {
        audioService.pause();
      }

      let offsetX = e.offsetX;
      let seekBarWidth = $(e.target).innerWidth();
      let seekProgressPercent = (offsetX / seekBarWidth) * 100;

      if (!this.isPlaying && (await audioService.stream(this.track)) === false) {
        return;
      }
      audioService.setTrackSeekPercent(seekProgressPercent);
    },

    onAudioServiceStreamTrack: function (info) {
      if (this.track.id == info.track.id) {
        if (this.nowPlaying != true) {
          this.nowPlaying = true;
          if (window.firstTrackPlayed == false) {
            setTimeout(function () {
              window.firstTrackPlayed = true;
            }, 500);
          }
        }
      } else {
        if (this.nowPlaying != false) {
          this.nowPlaying = false;
        }
      }
    },

    onWaveformToggled: function (waveformVisibility) {
      this.waveformVisible = waveformVisibility;
    },

    handleCollapseToggle: function () {
      this.$emit("toggle-expanded");
    },

    onWindowResize: function () {
      let ctx = this;

      // Check our track progress is up to date.
      $(function () {
        ctx.trackProgressVisualizerWidth = $(ctx.$el)
          .find(".track-progress-seek")
          .outerWidth();
      });
    },

    /**
     * Fires the events to init the track stream.
     */
    play: function () {
      audioService.stream(this.track);
    },

    onTrackClick: function (event) {
      let ctx = this;

      if (!$(event.target).hasClass("cancel-track-play")) {
        if (window.nowPlayingId != this.track.id) {
          audioService.stream(this.track);
        } else {
          if (
            !$(event.target).hasClass("track-progress-seek") &&
            !$(event.target).hasClass("track-progress-visualiser")
          ) {
            audioService.togglePlay();
          }
        }
      }
    },

    /**
     * Fires the event to load the download modal and display it.
     */
    download: function (e) {
      if (e.target.classList.contains("guest-download")) {
        playerService.downloadasGuest(this.track);
      } else {
        playerService.download(this.track);
      }
    },

    addToProject: function () {
      playerService.openAddProjectTrack(this.track);

      if (this.isMobile) {
        this.toggleTrackListMobileMenu();
      }
    },

    handleRemoveFromProjectClick: function () {
      if (this.isMobile) {
        this.toggleTrackListMobileMenu();
      }

      if (window.authenticatedUserEmail == false) {
        /** Remove from project as a guest - must be quicklist. **/

        this.removeTrackFromLsQuicklist();
      } else {
        if (this.projectId !== false) {
          playerService.removeProjectTrack(this.projectId, this.track.id);
        }
      }
    },

    removeFromProject: function () {
      if (this.isMobile) {
        this.toggleTrackListMobileMenu();
      }

      if (
        window.authenticatedUserEmail !== false &&
        this.projectId !== false &&
        this.projectId !== "quicklistGuest" &&
        this.isQuicklistProject()
      ) {
        playerService.removeProjectTrack(this.projectId, this.track.id, true);
        return;
      }

      this.removeFromProject();
    },

    openDetails: function () {
      playerService.openTrackDetails(this.track);

      if (this.isMobile) {
        this.toggleTrackListMobileMenu();
      }
    },

    openLyrics: function () {
      playerService.openTrackLyrics(this.track);
    },

    license: function () {
      playerService.openLicenseTrack(this.track);

      if (this.isMobile) {
        this.toggleTrackListMobileMenu();
      }
    },

    email: function () {
      playerService.shareTrack(this.track);

      if (this.isMobile) {
        this.toggleTrackListMobileMenu();
      }
    },

    findSimilar: function () {
      playerService.findSimilar(this.track);
    },

    // Manage quicklist, logged in & guest.
    onRightClick: function () {
      if (
        typeof this.track.id !== "undefined" &&
        this.track.id !== false &&
        window.authenticatedUserQuicklistId !== false
      ) {
        /** If logged in and has quicklist **/

        if (window.quicklistTrackIds.indexOf(this.track.id) !== -1) {
          /** Already in quicklist, remove it. **/

          playerService.removeProjectTrack(
            window.authenticatedUserQuicklistId,
            this.track.id,
          );

          // Optimistically remove from the local ID list so inQuicklist re-evaluates immediately.
          const removeIdx = window.quicklistTrackIds.indexOf(this.track.id);
          if (removeIdx !== -1) {
            window.quicklistTrackIds.splice(removeIdx, 1);
          }

          $(".track-list-row-" + this.track.id)
            .parent()
            .removeClass("in-quicklist");
        } else {
          /** Not in quicklist, add it. **/

          playerService.addProjectTrackByIds(
            window.authenticatedUserQuicklistId,
            this.track.id,
          );

          window.quicklistTrackIds.push(this.track.id);

          $(".track-list-row-" + this.track.id)
            .parent()
            .addClass("in-quicklist");

          if (
            $(".track-list-row-" + this.track.id)
              .closest("div.card-track-row")
              .hasClass("card-subtrack-row")
          ) {
            $(".track-list-row-" + this.track.id)
              .closest("div.card-track-parent-row")
              .find(".collapse-toggle i")
              .addClass("sub-track-in-quicklist");
          }
        }
      } else if (window.authenticatedUserEmail == false) {
        /** Guest Quicklist Management **/

        if (window.quicklistTrackIds.indexOf(this.track.id) !== -1) {
          // Already in quicklist, remove it.

          this.removeTrackFromLsQuicklist();
        } else {
          /** Not in quicklist, add it. **/

          this.addTrackToLsQuicklist();
        }
      }

      // Force Vue to re-evaluate inQuicklist so the menu item switches immediately.
      this.onQuicklistStateChanged();
    },

    toggleTrackListMobileMenu: function (childClass) {
      // Hide any other open project nav dropdowns.
      $(".track-list-row-template-container .dropdown-menu").css(
        "display",
        "none",
      );

      // Get current project nav dropdown elements.
      let $parentProjectNav = $(this.$el);
      let $childProjectNavDropdown = $("." + childClass);

      $childProjectNavDropdown.toggleClass("dropdown-open");

      if ($parentProjectNav.length && $childProjectNavDropdown.length) {
        if ($childProjectNavDropdown.hasClass("dropdown-open")) {
          // Turn it visible
          $childProjectNavDropdown.css("display", "block");

          // Position it relative to it's parent.
          window.positionWrapper($childProjectNavDropdown, {
            of: $parentProjectNav,
            at: "right bottom",
            my: "right top",
            collision: "flipfit",
          });
        }
      }
    },

    onAudioPlayerProgressUpdated: function (progress) {
      this.waveformProgress = progress;
    },

    handleProgressPercentUpdated: function (progress) {
      if (
        this.trackProgressVisualizerWidth == 0 ||
        this.trackProgressVisualizerWidth == null
      ) {
        this.trackProgressVisualizerWidth = $(this.$el)
          .find(".track-progress-seek")
          .outerWidth();
      }

      this.onAudioPlayerProgressUpdated(progress);
    },
  },

  watch: {
    nowPlaying: function (value) {
      let ctx = this;

      audioService.$off(
        "audio-service-progress-percent-updated",
        ctx.handleProgressPercentUpdated,
      );

      if (value) {
        $(this.$el).find(".track-list-row").addClass("track-list-now-playing");

        // Listen to the waveform status and update our intenral progress with it if applicabel
        setTimeout(function () {
          audioService.$on(
            "audio-service-progress-percent-updated",
            ctx.handleProgressPercentUpdated,
          );
        }, 250);

        ctx.isPlaying = true;
      } else {
        // Stop listening to any audio player progress updates as we dont need to update the waveform status.
        let $seekBar = $(this.$el).find(".track-progress-seek");

        // Kill any bindings to do with seek.
        $seekBar.off("mousewheel", "click", "mousemove", "mouseout");

        $(this.$el)
          .find(".track-list-row")
          .removeClass(
            "track-list-now-playing track-list-loading-track track-list-error-loading-track",
          );

        ctx.isPlaying = false;
      }
    },
  },
});
</script>
